import { AddContentModal } from "@/components/modals/AddContentModal";
import { CreateCollectionSheet } from "@/components/collections/CreateCollectionSheet";
import { AddItemsSheet } from "@/components/collections/AddItemsSheet";
import type { AddContentFlow } from "@/hooks/useAddContentFlow";

interface AddContentFlowOverlaysProps {
  flow: AddContentFlow;
  initialUrl?: string;
  initialNote?: string;
  disableModalInputs?: boolean;
  disableModalAddAnother?: boolean;
  onSaveLink?: (url: string) => void;
}

export function AddContentFlowOverlays({
  flow,
  initialUrl,
  initialNote,
  disableModalInputs = false,
  disableModalAddAnother = false,
  onSaveLink,
}: AddContentFlowOverlaysProps) {
  return (
    <>
      <AddContentModal
        isOpen={flow.isModalOpen}
        onClose={flow.closeModal}
        onSaveLink={onSaveLink}
        contentType={flow.contentType}
        initialFiles={flow.pendingFiles.length > 0 ? flow.pendingFiles : undefined}
        initialUrl={initialUrl}
        initialNote={initialNote}
        disableInputs={disableModalInputs}
        disableAddAnother={disableModalAddAnother}
      />

      <CreateCollectionSheet
        open={flow.createCollectionOpen}
        onOpenChange={flow.setCreateCollectionOpen}
        onCreated={flow.handleCollectionCreated}
      />

      {flow.newCollection && (
        <AddItemsSheet
          open={!!flow.newCollection}
          onOpenChange={flow.handleAddItemsClose}
          collectionId={flow.newCollection.id}
          collectionTitle={flow.newCollection.title}
          existingItems={[]}
          collectionVisibility={flow.newCollection.visibility}
        />
      )}
    </>
  );
}
